
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  DialogFooter,
} from '@/components/ui/dialog';

interface AddBikeFormProps {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
}

export const AddBikeForm: React.FC<AddBikeFormProps> = ({ onSubmit, loading }) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="grid gap-4 py-4">
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="serialNumber" className="text-right">
            Серийный номер
          </Label>
          <Input
            id="serialNumber"
            name="serialNumber"
            placeholder="SN-123456"
            className="col-span-3"
            required
          />
        </div>
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="model" className="text-right">
            Модель
          </Label>
          <Input
            id="model"
            name="model"
            placeholder="City Cruiser"
            className="col-span-3"
            required
          />
        </div>
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="mileage" className="text-right">
            Пробег (км)
          </Label>
          <Input
            id="mileage"
            name="mileage"
            type="number"
            placeholder="0"
            className="col-span-3"
            required
          />
        </div>
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="gpsTag" className="text-right">
            GPS-метка
          </Label>
          <Input
            id="gpsTag"
            name="gpsTag"
            placeholder="Введите идентификатор GPS-метки"
            className="col-span-3"
          />
        </div>
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="amoNumber" className="text-right">
            AMO номер
          </Label>
          <Input
            id="amoNumber"
            name="amoNumber"
            placeholder="Идентификатор в CRM"
            className="col-span-3"
          />
        </div>
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="status" className="text-right">
            Статус
          </Label>
          <Select defaultValue="available" name="status">
            <SelectTrigger className="col-span-3">
              <SelectValue placeholder="Выберите статус" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="available">Доступен</SelectItem>
              <SelectItem value="in_use">Используется</SelectItem>
              <SelectItem value="maintenance">Ремонт</SelectItem>
              <SelectItem value="retired">Списан</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <DialogFooter>
        <Button type="submit" disabled={loading}>Сохранить</Button>
      </DialogFooter>
    </form>
  );
};
